import { useEffect, useState } from "react";
import { fetchLinkTarget, getLinkTargetRef, normalizeTarget } from "../utils/linkTarget";

// Fetches the data behind a link's target and returns it normalized ({title, text, image}).
// Deliberately a hook used by the component that displays the data, not part of link parsing:
// links are everywhere in the SPA and only the card teaser needs the target's content.
// `enabled` lets the caller skip the request when nothing would use the result.
const useLinkTarget = (link, { enabled = true, lang } = {}) => {
    const ref = getLinkTargetRef(link);
    const { field, source, id } = ref || {};
    const key = ref ? `${field}|${source}|${id}` : null;
    const [state, setState] = useState({ key: null, target: {} });

    useEffect(() => {
        if (!enabled || !key) return;

        let cancelled = false;

        fetchLinkTarget({ field, source, id }, lang)
            .then((target) => !cancelled && setState({ key, target: normalizeTarget(field, target) }))
            .catch(() => !cancelled && setState({ key, target: {} }));

        return () => {
            cancelled = true;
        };
    }, [enabled, key, field, source, id, lang]);

    const ready = state.key === key;

    return { target: ready ? state.target : {}, loading: enabled && !!key && !ready };
};

export default useLinkTarget;
